import * as React from "react";

type Props = {
    panels: React.ReactNode[];
    colSpan: number;
};

class Panel extends React.Component<Props> {
    render() {
        const panels = this.props.panels.map((panel, i) => <div key={i}> {panel} </div>);
        return <div className="dsh_panel">{panels}</div>;
    }
}

export default Panel;
